export const settingsTrackIDs = {
    link: 'dagligbank-lokalbank-settings-link',
    userLink: 'dagligbank-lokalbank-user-settings-link',
    efakturaLink: 'dagligbank-lokalbank-efaktura-settings-link',
    communicationLink: 'dagligbank-lokalbank-communication-settings-link',
    signingMethodLink: 'dagligbank-lokalbank-signing-method-link',
    loginMethodLink: 'dagligbank-lokalbank-login-method-link',
};
